import React, { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import LayoutContainer from "../../components/Containers/LayoutContainer";
import CardComponent from "../../components/CommonCards/CardComponent";
import NoDataMessage from "../../components/noDataMessage/NoDataMessage";
import './myConnect.css';
import { postDetails, postMultipartDetails } from "../../services/http/http.service";
import APIList from "../../utils/constants/APIList";
import { PlusCircleFill } from "react-bootstrap-icons";
import { Modal, Button, Form, InputGroup } from "react-bootstrap";
import encrypt from "../../utils/helpers/encrypt";
import { validateImageFile } from "../../utils/helpers/validateFileUpload";
import { HiArrowSmallLeft } from "react-icons/hi2";
import PageHeader from "../../components/PageHeader/PageHeader";
import { hideLoader, showLoader } from "../../store/Loader/loader.slice";
import { useAppDispatch } from "../../store/storeRequests";
import { hideToast, showToast } from "../../store/Toast/toast.slice";

interface FolderData {
    id: number;
    created: string;
    modified: string;
    is_delete: number;
    folder_name: string;
    folder_image_name: string;
}

interface ConnectPayload {
    folder_name: string;
    myconnect_master_id: number;
}

const MyConnect: React.FunctionComponent = () => {
    const { id, title } = useParams<{ id: string; title: string }>();
    const [searchQuery, setSearchQuery] = useState("");
    const dispatch = useAppDispatch();

    const [folderData, setFolderData] = useState<FolderData[]>([]);
    const [editingFolderId, setEditingFolderId] = useState<number | null>(null);
    const [showAddModal, setShowAddModal] = useState(false);
    const [folder_name, setFolderName] = useState("");
    const [myconnectMasterId, setMyConnectMasterId] = useState<number>(0); 
    const [imageFile, setImageFile] = useState<File | null>(null);
    // const { myconnect_master_id } = useParams<{ myconnect_master_id: number}>();
    const navigate = useNavigate();
    const [validationErrors, setValidationErrors] = useState<{ folderName?: string; imageFile?: string }>({});
    const handleAddCard = () => setShowAddModal(true);
    const isUIMounted = useRef(false)
    const [showValidationModal, setShowValidationModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [contentIdToDelete, setContentIdToDelete] = useState<number | null>(null);
    const handleCloseDeleteModal = () => setShowDeleteModal(false);



    
    const handleCloseModal = () => {
      
        setShowAddModal(false);
        
        resetForm();
    };

    const resetForm = () => {
        setFolderName('');
        setValidationErrors({});
        setImageFile(null);
    };
    const fetchFolderData = async () => {
        if (id) {
            try {
                dispatch(showLoader("Loading data..."));
                const response = await postDetails(APIList.GET_FOLDER_DATA, { id });
                console.log(response);
                if (response.data) {
                    setFolderData(response.data);
                    setMyConnectMasterId(parseInt(id, 10));
                } else {
                    setFolderData([]);
                }
            } catch (error) {
                console.error("Error fetching folder data:", error);
                setFolderData([]);
            }
            finally {
                dispatch(hideLoader());
              }
        }
    };

    useEffect(() => {
        if(isUIMounted.current) return
        isUIMounted.current = true
        fetchFolderData();
    }, [id]);

    const handleSaveCard = async () => {
        
        const errors: { folderName?: string; imageFile?: string } = {};
        if (!folder_name) errors.folderName = "Folder name is required.";
        if (!imageFile) errors.imageFile = "Image file is required.";
        
        if (Object.keys(errors).length > 0) {
            setValidationErrors(errors);
            setShowValidationModal(true);
            if(showValidationModal){
                // alert("Please fill all required fields");
            }
            return;
        }
    
        
        const duplicateFolder = folderData.some(folder => folder.folder_name.toLowerCase() === folder_name.toLowerCase());
        if (duplicateFolder) {
           // alert("Folder with this name already exists.");
            dispatch(showToast("Folder with this name already exists."));
            setTimeout(() => dispatch(hideToast()), 3000);
            return;
        }
    
       
        const formData = new FormData();
        const payload: ConnectPayload = {
            folder_name,
            myconnect_master_id: myconnectMasterId,
        };
    
        formData.append('data', encrypt(payload));
        if (imageFile) {
            formData.append('mediafiles', imageFile);
        }
    
        try {
            const response = await postMultipartDetails(APIList.ADD_DATA, formData);
            if (response.statusCode === 200) {
                console.log("Data added successfully.");
                fetchFolderData();
                handleCloseModal();
                resetForm();
            } else if (response.message === "Data already present") {
                alert("Folder with this name already exists.");
            } else {
                console.error("Failed to add data:", response.message);
            }
        } catch (error) {
            console.error("Error adding data:", error);
            alert("An error occurred while adding the folder.");
        }
        
         finally {
            handleCloseModal();
        }
    };
    
    // const resetForm = () => {
    //     setFolderName("");  
    //     setImageFile(null); 
    // };
    const handleEditClick = (folderId: number) => {
        setEditingFolderId((prev) => (prev === folderId ? null : folderId));
    };

    const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>, folderId: number) => {
        const file = event.target.files ? event.target.files[0] : null;
        if (file) {
        
            const imageUrl = URL.createObjectURL(file);
            
    
          
            const updatedData = folderData.map((folder) =>
                folder.id === folderId ? { ...folder, folder_image_name: imageUrl } : folder
            );
            setFolderData(updatedData);
        }
    };
    
    const handleSearchChange = (event:any) => {
        setSearchQuery(event.target.value);
      };
    
      // Filter folderData based on the search query
      const filteredFolderData = folderData.filter(folder =>
        folder.folder_name.toLowerCase().includes(searchQuery.toLowerCase())
      ); 

    const handleUpdateClick = async (folderId: number) => {
        const updatedFolder = folderData.find((folder) => folder.id === folderId);
        if (!updatedFolder) return;

        try {
            const response = await postDetails(APIList.EDIT_DATA, updatedFolder);
            if (response.statusCode === 200) {
                setEditingFolderId(null);
            } else {
                console.error(response.message);
            }
        } catch (error) {
            console.error("Error updating folder:", error);
        }
    };
    const handleDelete = async (folderId: number) => {
        try {
            const payload = { id: folderId }; // Payload for delete request
            const response = await postDetails(APIList.DELETE_FOLDER, payload);
    
            if (response.statusCode === 200) {
                // Remove the deleted folder from the state
                setFolderData(prevData => prevData.filter(folder => folder.id !== folderId));
                console.log("Folder deleted successfully.");
                fetchFolderData(); 
            } else {
                console.error("Failed to delete folder:", response.message);
                fetchFolderData(); 
            }
        } catch (error) {
            console.error("Error deleting folder:", error);
        }
    };
    const handleDeleteClick = (id: number) => {
        setShowDeleteModal(true);
        setContentIdToDelete(id); // Store the content id
      };
    const handleTitleChange = (folderId: number, newTitle: string) => {
        const updatedData = folderData.map((folder) =>
            folder.id === folderId ? { ...folder, folder_name: newTitle } : folder
        );
        setFolderData(updatedData);
    };

    const handleViewItemsClick = async (folderId: number, folderName: string) => {
        const payload = {
            myconnect_folder_id: folderId, 
            myconnect_master_id: id ? parseInt(id, 10) : 0, 
        };
    
        try {
            const response = await postDetails(APIList.GET_FILTER_DATA, payload);
            console.log(payload);
            console.log('Items data response:', response.data.contentData);
    
            navigate(`/item-details/${folderId}/${folderName}`, {
                state: { contentData: response.data.contentData,myconnect_master_id:id,myconnect_folder_id:folderId }
               
            });
        } catch (error) {
            console.error('Error fetching items data:', error);
        }
    };
    
    const MAX_FILE_SIZE_MB = 15000000000000; 

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files ? event.target.files[0] : null;
    
        if (file) {
            const fileSizeMB = file.size / (1024 * 1024); 
    
            if (fileSizeMB > MAX_FILE_SIZE_MB) {
                alert(`File size exceeds the ${MAX_FILE_SIZE_MB} MB limit.`);
                setImageFile(null); 
                return;
            }
            if (file) {
                const validation = validateImageFile(file);
                if (!validation.valid) {
                  alert(validation.message);
                  event.target.value = ''; 
                  setImageFile(null);
                } else {
                    setImageFile(file); 
                }
              }
        }
    
            setImageFile(file);
           
    };
  

    const buttons = [
        {
            label: "Add Folder",
            theme: "warning",
            icon: <PlusCircleFill />,
            onClick: handleAddCard,
          },
        {
          label: "Back to MyConnect",
          theme: "warning",
          icon: <HiArrowSmallLeft />,
          onClick: () => navigate("/my-connect"), // Adjust the path as needed
        },
      ];
      

    return (
        <LayoutContainer title="Dashboard">
            <div className="page-header d-flex align-items-center justify-content-left dashboard-container h-100">
                <h2>
                    <i className="page-header-icon fa fa-dashboard"></i>
                    {title}
                </h2>
                
                {/* <button className="my-connect-btn" onClick={handleAddCard}>
                    <PlusCircleFill />
                    Add {title}
                </button> */}
            </div>
            <PageHeader buttons={buttons} />
            <div className="search-bar-container">
            <InputGroup style={{ width: "340px" }} className="mb-3">
          <Form.Control
            type="text"
            placeholder="Search..."
            value={searchQuery}
            onChange={handleSearchChange} // Search input handler
          />
        </InputGroup>
</div>
<div className="cards-container">
        {filteredFolderData.length === 0 ? (
          <NoDataMessage />
        ) : (
          filteredFolderData.map((folder) => (
            <CardComponent
              key={folder.id}
              image_name=""
              document_name=""
              title={folder.folder_name}
              FolderImage={folder.folder_image_name}
              createdDate={folder.created}
              onEditClick={() => handleEditClick(folder.id)}
              isEditing={editingFolderId === folder.id}
              onImageChange={(event) => handleImageChange(event, folder.id)}
              onUpdateClick={() => handleUpdateClick(folder.id)}
              update={editingFolderId === folder.id}
              onTitleChange={(newTitle) => handleTitleChange(folder.id, newTitle)}
              onDeleteClick={() => handleDeleteClick(folder.id)}
              isFolder={true}
              onViewItemsClick={() => handleViewItemsClick(folder.id, folder.folder_name)}
            />
          ))
        )}
      </div>

            {/* Modal Form for Adding New Data */}
            <Modal show={showAddModal} onHide={handleCloseModal}>
    <Modal.Header closeButton>
        <Modal.Title>Add New Folder</Modal.Title>
    </Modal.Header>
    <Modal.Body>
        <Form>
        <Form.Group controlId="formFolderName">
  <Form.Label>
    Folder Name <span style={{ color: 'red' }}>*</span>
  </Form.Label>
  <Form.Control
    type="text"
    placeholder="Enter folder name"
    value={folder_name}
    isInvalid={!!validationErrors.folderName || folder_name.length > 50} 
    onChange={(e) => {
      if (e.target.value.length <= 50) {
        setFolderName(e.target.value);
      }
    }}
  />
  {(validationErrors.folderName || folder_name.length > 50) && (
    <Form.Text className="text-danger">
      {validationErrors.folderName || "Folder Name cannot exceed 150 characters."}
    </Form.Text>
  )}

  <div className="text-muted">
    {folder_name.length}/50
  </div>
</Form.Group>

            <Form.Group controlId="formFile">
                <Form.Label>
                  Select Image<span style={{ color: 'red' }}>*</span>
                </Form.Label>
                <Form.Control
                    type="file"
                    accept="image/*"
                    isInvalid={!!validationErrors.imageFile} // Show error if validation fails
                    onChange={handleFileChange}
                />
     <Form.Text className="text-mute">
    Uploads must be  JPG/JPEG/PNG
    </Form.Text>
    <div>
                {validationErrors.imageFile && (
                    <Form.Text className="text-danger">
                        {validationErrors.imageFile}
                    </Form.Text>
                )}
                </div>
            </Form.Group>
        </Form>
    </Modal.Body>
    <Modal.Footer>
        <button className="my-connect-cancel-btn" onClick={handleCloseModal}>
            Close
        </button>
        <button className="my-connect-add-btn"  onClick={handleSaveCard}>
            Add
        </button>
    </Modal.Footer>
</Modal>

<Modal show={showDeleteModal} onHide={handleCloseDeleteModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn-warning" onClick={handleCloseDeleteModal}>
            Cancel
          </Button>
          <Button className="btn-danger"onClick={() => {
        if (contentIdToDelete !== null) {
          handleDelete(contentIdToDelete); // Use the stored id to delete the content
        }
        setShowDeleteModal(false); // Close the modal after deletion
      }}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

            {/* <Modal show={showValidationModal} onHide={() => setShowValidationModal(false)}>
    <Modal.Header closeButton>
        <Modal.Title>Validation Error</Modal.Title>
    </Modal.Header>
    <Modal.Body>
        <p>Please fill all the necessary fields before adding the folder.</p>
    </Modal.Body>
    <Modal.Footer>
        <Button variant="primary" onClick={() => setShowValidationModal(false)}>
            OK
        </Button>
    </Modal.Footer>
</Modal> */}

        </LayoutContainer>
    );
};

export default MyConnect;


